import React, { useEffect, useState } from 'react';
// Libraries
import { SearchOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { Alert, Result } from 'antd';
// Own Components
import PeopleList from './components/PeopleList';
// Components
import Title from '~/components/typography/title';
import Button from '~/components/button';
import Loading from '~/components/loading';
import SearchDrawer from '~/pages/SIGAM/components/SearchDrawer';
// Utils
import SocialMeAPI from '~/utils/SocialMeAPI';
// Pages
import SearchDrawerComponent from './components/SearchDrawerComponent';

export default function Signatories({ document, propertys }) {
    const { institutionId, organizationUnitId } = useParams();
    const [people, setPeople] = useState([]);
    const [loadingContent, setLoadingContent] = useState(true);
    const [accessLevel, setAccessLevel] = useState();

    const documentInformation = document || propertys.document[0];
    
    async function GetPeopleAgain() {
        if (propertys && propertys.GetDataAgain) {
            propertys.GetDataAgain();
        }
        const params = {
            operation: ['SIGAM', 'Documents', 'Signatories', 'Get'],
            urlParams: {
                institutionId,
                organizationUnitId,
                documentId: documentInformation.id
            }
        };
        const response = await SocialMeAPI(params);
        if (response.success) {
            setPeople(response.body.signatory.elements);
        }
    }

    useEffect(() => {
        async function GetPeople() {
            const params = {
                operation: ['SIGAM', 'Documents', 'Signatories', 'Get'],
                urlParams: {
                    institutionId,
                    organizationUnitId,
                    documentId: documentInformation.id
                }
            };
            const response = await SocialMeAPI(params);
            if (response.success) {
                setPeople(response.body.signatory.elements);
            }
            setLoadingContent(false);
        }
        async function verifyPermission() {
            const params = {
                operation: ['SIGAM', 'Documents', 'HavePermission'],
                urlParams: {
                    institutionId,
                    organizationUnitId,
                    documentId: documentInformation.id
                }
            };
            const response = await SocialMeAPI(params);
            setAccessLevel(response.body.access_level);
            GetPeople();
        }
        verifyPermission()
    }, [documentInformation, institutionId, organizationUnitId])

    if (documentInformation.kind === 'EXTERNAL') {
        return <Result
                status="error"
                title="Um documento externo não permite assinaturas"
                subTitle="Caso você queira assinar esse documento, recomenda-se criar um documento digital na plataforma e adicionar esse documento como anexo"
            />
    }

    return (
        <div>
            {accessLevel && accessLevel.is_in_charge === false && <Alert style={{ marginBottom: '10px' }} message="Você não tem permissão para alterar o documento" type="warning" showIcon />}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                <Title level={5}>Assinantes</Title>
                {accessLevel && accessLevel.is_in_charge && <SearchDrawer
                    Trigger={
                        <Button icon={<SearchOutlined />}>Buscar Usuário</Button>
                    }
                    title="Novo Assinante"
                    SecondStepComponent={SearchDrawerComponent}
                    secondStepParameters={{ document: documentInformation, people, GetPeopleAgain, searchOnSocialMe: true, }}
                />}
            </div>
            {loadingContent ?
                <Loading />
                :
                <PeopleList people={people} document={documentInformation} GetPeopleAgain={GetPeopleAgain} accessLevel={accessLevel} />
            }
        </div>
    )
}